var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgChevronBack(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 19,
    viewBox: "0 0 12 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.976117 8.40225C0.487961 8.8904 0.487961 9.68186 0.976116 10.17L8.93107 18.125C9.41922 18.6131 10.2107 18.6131 10.6988 18.125C11.187 17.6368 11.187 16.8454 10.6988 16.3572L3.62777 9.28613L10.6988 2.21507C11.187 1.72691 11.187 0.935454 10.6988 0.447299C10.2107 -0.0408566 9.41922 -0.0408567 8.93107 0.447299L0.976117 8.40225ZM2 8.03613L1.86 8.03613L1.86 10.5361L2 10.5361L2 8.03613Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChevronBack);
export default __webpack_public_path__ + "static/media/chevron-back.bad707250c56bb02a091b9941dbf7ddd.svg";
export { ForwardRef as ReactComponent };